/**
 * Custom hook for mobile device detection.
 * Uses Tailwind's `md` breakpoint (768px) as the threshold.
 */

import { useState, useEffect } from 'react';

const MOBILE_BREAKPOINT = 768;

/**
 * Detects if the current viewport is mobile-sized.
 * Updates automatically on window resize.
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < MOBILE_BREAKPOINT;
  });

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);

    const handleChange = (e: MediaQueryListEvent) => {
      setIsMobile(e.matches);
    };

    // Listen for changes (initial value already set in useState)
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return isMobile;
}
